import templateUrl from "emun.swatch/swatchcount-edit.htm";
import controller from "emun.swatch/swatchcount-edit.controller";

export default {
  controller,
  bindings: {
    countId: "@",
  },
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
